// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"5e2ece6e","119":"cb922527","209":"fdd6fd6b","499":"a1bb791b","551":"b5903e2c","618":"876dd3a3","760":"04b3539f","787":"0f116148"}[chunkId] + ".chunk.js";
};